import { isValidConsolidationDate } from "./consolidationViewStorage.js";

const PREFIX = "grain-saas:consolidation:orders-return:v1:";
const memory = new Map();
export const orderNavigationScope = (userId, companyId) => userId && companyId ? `${userId}:${companyId}` : "";

export function groupConsolidationOrders(orders) {
  const groups = new Map(), missing = [];
  for (const order of [...new Map(orders.map(order => [order.order_id, order])).values()]) {
    if (!isValidConsolidationDate(order.delivery_date)) { missing.push(order.order_id); continue; }
    if (!groups.has(order.delivery_date)) groups.set(order.delivery_date, []);
    groups.get(order.delivery_date).push(order.order_id);
  }
  return { days: [...groups].sort(([a], [b]) => a.localeCompare(b)).map(([date, ids]) => ({ date, ids })), missing };
}

export function consolidationOrdersUrl(date, ids, token) {
  const params = new URLSearchParams({ date, view: "sheets" });
  [...new Set(ids)].forEach(id => params.append("order_id", id));
  if (token) params.set("return_context", token);
  return `/consolidation?${params}`;
}

// Facturation → Consolidation : l'adresse emporte la facture ouverte ; « Retour à la facture » la rouvre.
export function withInvoiceReturn(url, invoiceId) {
  if (!url || !invoiceId) return url;
  const target = new URL(url, "http://local");
  target.searchParams.set("return_invoice", invoiceId);
  return `${target.pathname}${target.search}${target.hash}`;
}

// Chemin fixe vers Facturation : le paramètre ne choisit que la facture, jamais la destination.
export const invoiceReturnUrl = invoiceId => invoiceId ? `/billing?${new URLSearchParams({ tab: "invoices", invoice_id: invoiceId })}` : null;

export function saveOrdersReturn(scope, context) {
  if (!scope) return;
  memory.set(scope, context);
  try { window.sessionStorage.setItem(PREFIX + scope, JSON.stringify(context)); } catch { /* Session memory fallback. */ }
}

export function readOrdersReturn(scope, token) {
  if (!scope || !token) return null;
  let value;
  try { value = JSON.parse(window.sessionStorage.getItem(PREFIX + scope)); } catch { /* Session memory fallback. */ }
  value ||= memory.get(scope);
  return value?.token === token && /^\/data-manager(?:\?|$)/.test(value.url) ? value : null;
}

export function findConsolidationOrders(days, ids) {
  const found = new Set(), unassigned = new Set();
  for (const day of days) {
    const routes = [...day.driver_groups.flatMap(group => group.routes), ...day.unassigned_routes];
    for (const route of routes) for (const order of [...route.orders, ...route.sheet.visits.flatMap(visit => visit.orders)]) {
      if (ids.has(order.label)) found.add(order.label);
    }
    for (const order of day.unassigned_orders) if (ids.has(order.label)) { found.add(order.label); unassigned.add(order.label); }
    for (const sheet of day.manual_order_sheets || []) for (const order of sheet.visits.flatMap(v => v.orders)) {
      if (ids.has(order.label)) { found.add(order.label); unassigned.add(order.label); }
    }
  }
  return { missing: [...ids].filter(id => !found.has(id)), unassigned: [...unassigned] };
}

export function captureOrdersScroll(root) {
  const elements = root ? [root, ...root.querySelectorAll("*")] : [];
  let parent = root?.parentElement;
  while (parent) { elements.push(parent); parent = parent.parentElement; }
  return elements.filter(element => /(auto|scroll)/.test(`${getComputedStyle(element).overflowY} ${getComputedStyle(element).overflowX}`))
    .map((element, index) => ({ index, top: element.scrollTop, left: element.scrollLeft }));
}

export function restoreOrdersScroll(root, positions) {
  const elements = root ? [root, ...root.querySelectorAll("*")] : [];
  let parent = root?.parentElement;
  while (parent) { elements.push(parent); parent = parent.parentElement; }
  elements.filter(element => /(auto|scroll)/.test(`${getComputedStyle(element).overflowY} ${getComputedStyle(element).overflowX}`))
    .forEach((element, index) => { const saved = positions?.find(value => value.index === index); if (saved) { element.scrollTop = saved.top; element.scrollLeft = saved.left; } });
}
